import Link, { type LinkProps } from 'next/link';
import type { AnchorHTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

type MHLinkBaseProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'>;

export interface MHLinkProps extends MHLinkBaseProps {
  href: LinkProps['href'];
  tone?: 'default' | 'legal';
}

export function MHLink({ className, href, tone = 'default', ...props }: MHLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        'transition-colors duration-hover ease-calm focus-visible:rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg-0 underline-offset-2',
        tone === 'legal'
          ? 'text-link underline decoration-text-tertiary hover:text-link-hover'
          : 'text-text-secondary hover:text-link-hover hover:underline focus-visible:underline',
        className
      )}
      {...props}
    />
  );
}
